import { api } from '../../utils';
import { Map, fromJS } from 'immutable';
import actions from '@synergycms_app/store/actions';
import { pick,omit,keys } from 'ramda';
import * as R from 'ramda';

const engineMainConfig = (main, alter, fromServer)=> {
  const appCode ="cms-engine";
  const appMain = main[appCode] || {};
  const configMain = main[appCode]?.config || {};
  const fromServerMainConfig = main[appCode]?.config;

  const appAlter = alter[appCode] || {};
  const configAlter = alter[appCode]?.config || {};
  return {
    ...alter,
    ...main,
    [appCode] : {
      ...appAlter,
      ...appMain,
      avail_url: main.avail_url || alter.avail_url,
      config : {
        engine_active : true,
        ... R.mergeDeepRight(configAlter, configMain),
        engine_active: (fromServerMainConfig || configMain).engine_active || true,
        prices_active : (fromServerMainConfig || configMain).prices_active,
      }
    }
  };
};

const remapObject = (source, pathMap) => {
  const mapped = R.pipe(
    R.toPairs,
    R.map(([key, path]) => {
      const value = source[key];
      return R.is(Array, path)
        ? R.assocPath(path, value, {})
        : { [path]: value };
    }),
    R.reduce(R.mergeDeepRight, {})
  )(pathMap);

  const unmapped = R.omit(R.keys(pathMap), source);

  return R.mergeDeepRight(mapped, unmapped);
};

const pickPaths = (requiredFields, data) =>{
  const toPathArray = (p) => Array.isArray(p) ? p : [p];

  return  R.pipe(
    R.toPairs,
    R.filter(([_, path]) =>
      R.path(toPathArray(path), data) === undefined
    ),
    R.map(R.head)
  )(requiredFields)
}

export default {
  LOADED : {
    GET: val => (val)
  },
  NAME: {
    GET: name => (name)
  },
  OUTER_WEB: {
    GET: val => (val)
  },
  CONFIG: {
    GET_HOTEL : (hotelId, config) => ({config,hotelId}),
    GET : (config,hotelId) => ({config,hotelId}),
    GET_ASYNC : (app, config) => (dispatch, getState) => {
      const store = getState();
      // return empty promise if currencies are already loaded
      if (!store.get("group") || store.getIn(['app', 'config']) ) {
        return Promise.resolve();
      }
      const deviceType = store.getIn(['system', 'device'])
      let device = (deviceType !== 'desktop') ? `,device:${deviceType}` : '';
      const url = `,url:${window.location.pathname}`;

      let query = {
        q: `app:${app},group:${store.get("group")}${device}${url}`,
      }

      return (!config ?
        api.get('frontend/config', query) :
        Promise.resolve(config)).then((result) => {;
          return Map(result);
      });
    },
    GET_HOTEL_ASYNC : (app, hotel, windowConfig) => (dispatch, getState) => {
      const store = getState();
      // return empty promise if currencies are already loaded

      if ( !hotel || store.getIn(['app', 'hotelConfig', hotel] )) {
        return Promise.resolve();
      }

      const deviceType = store.getIn(['system', 'device'])
      let device = (deviceType !== 'desktop') ? `,device:${deviceType}` : '';
      const url = `,url:${window.location.pathname}`;

      let query = {
        q: `app:${app},hotel:${hotel}${device}${url}`,
      };

      let promiseConfig = !windowConfig ? api.get('frontend/config', query) : Promise.resolve(windowConfig);
      return promiseConfig.then((config) => {
          return fromJS({ [hotel] : config});
        });
    },
    GET_ENGINE_ASYNC : (windowConfig, hotel) => (dispatch, getState) => {
    const store = getState();
    const webType= store.getIn(["customer","web_type"]);
    // return empty promise if currencies are already loaded
    const app = "cms-engine";
    const group = windowConfig.group;
    if (webType === "WI" && (!hotel || (hotel && store.getIn(['app', 'hotelConfig', hotel])))) {
      return Promise.resolve();
    } else if (webType === "PORTAL" && !windowConfig.group || store.getIn(['app', 'config']) ) {
      return Promise.resolve();
    }
    const deviceType = store.getIn(['system', 'device'])
    let device = (deviceType !== 'desktop') ? `,device:${deviceType}` : '';
    const url = `,url:${window.location.pathname}`;
    let entityQuery = webType === "PORTAL" ? (',group:'+group) : (",hotel:"+hotel);

    let query = {
      q: `app:${app}${entityQuery}${device}${url}`,
    };

    let promiseConfig = Promise.resolve(windowConfig);

    const requiredFields = { i18n : [app, 'i18n'], lang_info: 'lang_info', avail_url: [app, "config", "avail_url"], config:[app, "config"] };
    webType === "PORTAL" && (requiredFields["hotels_info"] = "hotels_info");

    const missingFields = pickPaths(requiredFields, windowConfig);

    const forceWindowConfig = windowConfig?.[app]?.config?.ignore_synergy_config;
    const requestedFields = (forceWindowConfig ? missingFields : keys(requiredFields));
    query.i= requestedFields.join(",");

    if (!forceWindowConfig || missingFields.length) {
      promiseConfig = api.get('frontend/config/engine', query).then((serverConfig) => {
        const genericServerConfig = remapObject(serverConfig, requiredFields);
        //FORCE FROM WINDOW
        const serverforceFromWindow = serverConfig.config.ignore_synergy_config;
        //construim la config a partir de
        return serverforceFromWindow ? engineMainConfig(windowConfig, genericServerConfig, genericServerConfig) : engineMainConfig(genericServerConfig, windowConfig);
      });
    }

    return promiseConfig
      .then((finalConfig) => {
        dispatch(actions.customer.langInfo.get(finalConfig.lang_info));
        dispatch(actions.hotels.info.get(finalConfig.hotels_info));
        dispatch(actions.app.outerWeb.get(finalConfig[app].config.outer_web));
        dispatch(actions.group.get(finalConfig.group));
        /*if (finalConfig['cms-login']) {
          finalConfig = set(lensPath(hotel? [hotel,"cms-login"] : [hotel,"cms-login"]), config['cms-login'], hotelConfig);
        }*/
        dispatch(actions.app.config.get({...pick(["i18n"], finalConfig[app]), ...finalConfig[app].config},hotel));
        return finalConfig;
      }).catch((err)=>{
        console.log("configError",err);
      });
    }
  },
};
